import axios from "axios"

export const BASE_URL = "https://api.bosspanda.io/"
export const TOKEN = "CjGAECd9J9J7eK57bcE58hEF"

export const CURRENT_IP = window.localStorage.getItem('bpipos')?window.localStorage.getItem('bpipos'):'224.234.50.218'

